var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageMobileNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_2517_12317)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.4993 16.3333L20.9993 12.8333H12.8327C12.5233 12.8333 12.2265 12.7104 12.0077 12.4916C11.7889 12.2728 11.666 11.9761 11.666 11.6667V4.66667C11.666 4.35725 11.7889 4.0605 12.0077 3.84171C12.2265 3.62292 12.5233 3.5 12.8327 3.5H23.3327C23.6421 3.5 23.9388 3.62292 24.1576 3.84171C24.3764 4.0605 24.4993 4.35725 24.4993 4.66667V16.3333Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.3333 17.4993V19.8327C16.3333 20.1421 16.2104 20.4388 15.9916 20.6576C15.7728 20.8764 15.4761 20.9993 15.1667 20.9993H7L3.5 24.4993V12.8327C3.5 12.5233 3.62292 12.2265 3.84171 12.0077C4.0605 11.7889 4.35725 11.666 4.66667 11.666H7",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 4.5,
    r: 4,
    fill: "url(#paint0_linear_1732_970)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1732_970",
    x1: 15,
    y1: 8,
    x2: 22.6387,
    y2: 3.75298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E1F63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9892,
    stopColor: "#ED4663"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1732_970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageMobileNew);
export default __webpack_public_path__ + "static/media/messageMobileNew.f55a37a4e720f15487d252425de639e2.svg";
export { ForwardRef as ReactComponent };